import { MultiFieldTextQuestion } from "./questionTypes";

interface MultiFieldTextQuestionProps {
  question: MultiFieldTextQuestion;
  values: Record<string, string>;
  onChange: (questionId: string, values: Record<string, string>) => void;
}

export function MultiFieldTextQuestionComponent({
  question,
  values,
  onChange
}: MultiFieldTextQuestionProps) {
  const handleFieldChange = (fieldId: string, value: string) => {
    const newValues = { ...values, [fieldId]: value };
    onChange(question.id, newValues);
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-2">{question.title}</h2>
        {question.description && (
          <p className="text-muted-foreground mb-6">{question.description}</p>
        )}
      </div>
      
      <div className="space-y-4">
        {question.fields.map((field) => (
          <div key={field.id} className="space-y-2">
            <label className="text-sm font-medium text-foreground">
              {field.label}
              {field.required && <span className="text-destructive ml-1">*</span>}
            </label>
            
            {field.type === 'select' && field.options ? (
              <select
                value={values[field.id] || ''}
                onChange={(e) => handleFieldChange(field.id, e.target.value)}
                className="w-full p-3 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                required={field.required}
              >
                <option value="">{field.placeholder || `Select ${field.label}`}</option>
                {field.options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type={field.type || 'text'}
                value={values[field.id] || ''}
                onChange={(e) => handleFieldChange(field.id, e.target.value)}
                placeholder={field.placeholder}
                className="w-full p-3 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                required={field.required}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}